import { render, staticRenderFns } from "./BallotStatus.vue?vue&type=template&id=50b6f976&"
import script from "./BallotStatus.vue?vue&type=script&lang=js&"
export * from "./BallotStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports